import type { TFunction } from 'i18next';

import type { IApiOrganizationUserRole } from '~/lib/api/modules/Organizations';

export const getOrganizationRoleLabel = (
  role: IApiOrganizationUserRole,
  t: TFunction<'translation', undefined>,
): string => {
  switch (role) {
    case 'member':
      return t('OrganizationRoleSelector.member.label');
    case 'admin':
      return t('OrganizationRoleSelector.admin.label');
    case 'owner':
      return t('OrganizationRoleSelector.owner.label');
  }
};
